export default class PayAgreementContragent {
  constructor({id, name, type, legal, legals, allow, client, operator}) {
    this._id = id;
    this._name = name;
    this._type = type;
    this._legal = legal;
    this._legals = legals;
    this._allow = allow;
    this._client = client;
    this._operator = operator;
  }

  get id() {
    return this._id;
  }

  get value() {
    return this._id;
  }

  get name() {
    return this._name;
  }

  get label() {
    return this._name;
  }

  get type() {
    return this._type;
  }

  get allow() {
    return this._allow;
  }

  get client() {
    return this._client;
  }

  get hiddenClient() {
    return !this._client;
  }

  get operator() {
    return this._operator;
  }

  get hiddenOperator() {
    return !this._operator;
  }

  get legal() {
    return this._legal;
  }

  get legals() {
    return this._legals;
  }

  static setClients(data) {
    const contragents = [];
    data.ClientContractorsData.Contragents.forEach(contragent => {
      contragents.push(new PayAgreementContragent({
        id: contragent.Id,
        name: contragent.Name,
        type: 1,
        legal: 0,
        legals: [{label: '<не указано>', value: 0}],
        allow: false,
        client: false,
        operator: false,
      }))
    });
    return contragents;
  }

  static setPartners(data) {
    const contragents = [];
    data.ClientPartnerContractorsData.Contragents.forEach(contragent => {
      contragents.push(new PayAgreementContragent({
        id: contragent.Id,
        name: contragent.Name,
        type: 2,
        legal: contragent.LegalEntities[0].Id,
        legals: contragent.LegalEntities.map(i => ({value: i.Id, label: i.Name})),
        allow: false,
        client: false,
        operator: false,
      }))
    });
    return contragents;
  }

  static setOperators(data) {
    const contragents = [];
    data.PartnerContractorsData.Contragents.forEach(contragent => {
      let item = contragents.find(i => i.id === contragent.Id);
      let legal = contragent.LegalEntities.find(i => i.Id === contragent.SelectedLegalEntityId);
      if (item) {
        if (!item.legals.find(i => i.value === legal.Id)) item._legals.push({value: legal.Id, label: legal.Name});
      } else {
        contragents.push(new PayAgreementContragent({
          id: contragent.Id,
          name: contragent.Name,
          type: 3,
          legal: legal ? legal.Id : 0,
          legals: legal ? [{value: legal.Id, label: legal.Name}] : [{label: '<не указано>', value: 0}],
          allow: false,
          client: false,
          operator: false,
        }));
      }
    });
    return contragents;
  }

  static setSubAgentAndRC(data) {
    if (!data.PaymentsData.ReservationCenterOrdersPayments.length) return [];
    const contragents = [];
    data.ReservationCenterContractorsData.Contragents.forEach(contragent => {
      let item = contragents.find(i => i.id === contragent.Id);
      let legal = contragent.LegalEntities.find(i => i.Id === contragent.SelectedLegalEntityId);
      if (item) {
        if (!item.legals.find(i => i.value === legal.Id)) item._legals.push({value: legal.Id, label: legal.Name});
      } else {
        contragents.push(new PayAgreementContragent({
          id: contragent.Id,
          name: contragent.Name,
          type: 7,
          legal: legal ? legal.Id : 0,
          legals: legal ? [{value: legal.Id, label: legal.Name}] : [{label: '<не указано>', value: 0}],
          allow: data.PaymentsData.IsReservationCenter && data.PaymentsData.AllowViewSubAgentData,
          client: !(data.PaymentsData.ForReservationCenter && data.PaymentsData.IsReservationCenter),
          operator: !(data.PaymentsData.ForReservationCenter && data.PaymentsData.IsSubAgent),
        }));
      }
    });
    return contragents;
  }

  static setContragents(data) {
    return [
      ...PayAgreementContragent.setClients(data),
      ...PayAgreementContragent.setPartners(data),
      ...PayAgreementContragent.setOperators(data),
      ...PayAgreementContragent.setSubAgentAndRC(data),
    ]
  }
}